import {
  EXCHANGE_ORDER_FAILURE,
  EXCHANGE_ORDER_REQUEST,
  EXCHANGE_ORDER_SUCCESS,
} from "../actions/exchangeOrderAction";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const exchangeOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case EXCHANGE_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case EXCHANGE_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case EXCHANGE_ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.error,
      };
    default:
      return state;
  }
};
